import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { Image } from './files/Image.js';
export class OrganizationInvoiceSettings extends AutoEncoder {
    /**
     * Whether we reset the invoice numbers yearly on the start of this month.
     * Disabled by default.
     *
     * 1 = january
     */
    resetMonth;
    padZeroLength;
    /**
     * If this is set to true, resetMonth is expected to be 1 (january)
     */
    prefixYear;
    /**
     * To differentiate multiple invoice numbering systems used across multiple online systems
     * E.g. 'STA-', 'KEEO-
     */
    fixedPrefix;
    background;
    /**
     * Use a different background for the 2nd and later backgrounds
     */
    secondBackground;
    /**
     * Send a copy of invoice XML to these email addresses.
     * Generally the go to way for implementing PEPPOL or importing it in your finance system.
     */
    forwardEmailHandlers;
    /**
     * Only send XML's for customers with a VAT number OR custom peppol endpoint
     */
    forwardOnlyVAT;
}
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], OrganizationInvoiceSettings.prototype, "resetMonth", void 0);
__decorate([
    field({ decoder: IntegerDecoder, defaultValue: () => 6 })
], OrganizationInvoiceSettings.prototype, "padZeroLength", void 0);
__decorate([
    field({ decoder: BooleanDecoder, defaultValue: () => false })
], OrganizationInvoiceSettings.prototype, "prefixYear", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OrganizationInvoiceSettings.prototype, "fixedPrefix", void 0);
__decorate([
    field({ decoder: Image, nullable: true })
], OrganizationInvoiceSettings.prototype, "background", void 0);
__decorate([
    field({ decoder: Image, nullable: true })
], OrganizationInvoiceSettings.prototype, "secondBackground", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), ...NextVersion })
], OrganizationInvoiceSettings.prototype, "forwardEmailHandlers", void 0);
__decorate([
    field({ decoder: BooleanDecoder, ...NextVersion, defaultValue: () => true })
], OrganizationInvoiceSettings.prototype, "forwardOnlyVAT", void 0);
//# sourceMappingURL=OrganizationInvoiceSettings.js.map